export const OptionPills = ({ options, value, onChange, testId }) => (
  <div className="flex flex-wrap gap-2" data-testid={testId}>
    {options.map((o) => (
      <button
        type="button"
        key={o}
        onClick={() => onChange(o)}
        data-testid={`${testId}-${String(o).replace(".", "_")}`}
        className={`pick-btn min-w-11 h-9 px-3 rounded-full border text-sm font-semibold ${
          value === o ? "bg-emerald-500 border-emerald-500 text-[#0A0D14]" : "border-[#26334D] text-slate-300 hover:border-emerald-500/60"
        }`}
      >
        {o}
      </button>
    ))}
  </div>
);
